import { Arrange, Skeleton, Spacer } from "@aviary";

import * as styles from "../ProductResultsHeader.styles";

const SkeletonEmersonProductResultsHeader = () => {
  return (
    <div>
      <Arrange isVertical>
        <Skeleton type="typography" typographySize="h3" width={6} css={styles.titleSkeleton} />
        <Skeleton type="typography" width={6} />
      </Arrange>
      <div>
        <Arrange justify="spaceBetween" css={styles.margin}>
          <Skeleton
            type="typography"
            typographySize="h1"
            width={8}
            css={styles.sortDropdownSkeleton}
          />
          <Skeleton
            type="typography"
            typographySize="h1"
            width={8}
            css={styles.sortDropdownSkeleton}
          />
        </Arrange>
        <Spacer height="one" />
      </div>
    </div>
  );
};

export { SkeletonEmersonProductResultsHeader };
